var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3507 22.7247L8.30126 25.4989C7.61919 25.8736 6.77558 25.5996 6.417 24.8868C6.27421 24.603 6.22494 24.2779 6.27681 23.9618L7.24118 18.0861C7.31881 17.6131 7.16875 17.1305 6.83991 16.7955L2.75479 12.6343C2.20299 12.0722 2.1917 11.1491 2.72957 10.5724C2.94375 10.3428 3.2244 10.1934 3.52806 10.1473L9.17355 9.29C9.628 9.22099 10.0209 8.92272 10.2241 8.49238L12.7488 3.14643C13.0899 2.42432 13.9265 2.12784 14.6175 2.48422C14.8927 2.62614 15.1154 2.85888 15.2512 3.14643L17.7759 8.49238C17.9792 8.92272 18.372 9.22099 18.8265 9.29L24.472 10.1473C25.2345 10.2631 25.7629 11.0029 25.6521 11.7998C25.608 12.1172 25.465 12.4104 25.2452 12.6343L21.1601 16.7955C20.8313 17.1305 20.6812 17.6131 20.7588 18.0861L21.7232 23.9618C21.8535 24.7555 21.3434 25.5093 20.5839 25.6454C20.2815 25.6996 19.9704 25.6481 19.6988 25.4989L14.6493 22.7247C14.2428 22.5014 13.7572 22.5014 13.3507 22.7247Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/ic-star.e4906fbc.svg";
export { ForwardRef as ReactComponent };